import React from 'react';
import { connect } from 'react-redux';
import { getOnboardingState, getTenantState } from '../../../store/selectors';
import BoxWithShadow from '../basic-style-components/BoxWithShadow';
import { tenantsCopy as copy } from '../../../copy/advisor-dashboard/tenants-tab.json';
import {
  getAllTenants,
  getTenantDetails,
  updatePublishedAndGetTenants,
} from '../../../store/actions';
import Tenant from './Tenant';
import CreateModal from './CreateModal';
import EditModal from './EditModal';
import UpdateCareersModal from './UpdateCareersModal';
import UpdateDegreesModal from './UpdateDegreesModal';
import Loading from '../../utility/Loading';
import XIcon from '../../utility/XIcon';

export class Tenants extends React.Component {
  _isMounted = false;

  constructor(props) {
    super(props);
    this.state = {
      displayModal: false,
      allTenants: [],
      loading: false,
      modalType: '',
    };
  }

  colorPrimary = {
    color: `${this.props.tenant.primary}`,
  };

  plusIcon = {
    border: `2px solid ${this.props.tenant.primary}`,
    color: this.props.tenant.primary,
  };

  openTenantModal = (modalType, tenantId = null) => {
    console.log('open called')
    this.setState(
      {
        loading: true,
      },
      async () => {
        const tenantDetails =
          modalType === 'Create'
            ? undefined
            : await this.props.getTenantDetails(tenantId);
        this.setState({
          displayModal: true,
          tenantDetails,
          modalType,
          loading: false,
        });
      }
    );
  };

  refreshTenants = async () => {
    const tenants = await this.props.getAllTenants();
    this.setState({
      allTenants: tenants,
    });
  };

  componentDidMount = async () => {
    let tenants;
    if (this.props.role !== 'Super User') {
      tenants = [this.props.tenant];
    } else {
      tenants = await this.props.getAllTenants();
    }
    this.setState({
      allTenants: tenants,
    });
  };

  closeTenantModal = () => {
    this.setState({
      displayModal: false,
      tenantDetails: {},
      modalType: '',
    });
  };

  updatePublishedAndRefresh = async (tenantId) => {
    const tenants = await this.props.updatePublishedAndGetTenants(tenantId);
    this.setState({
      allTenants: tenants,
    });
  };

  modalController = () => {
    const { modalType } = this.state;
    return (
      <>
        {modalType === 'Create' && (
          <CreateModal refreshTenants={this.refreshTenants} />
        )}
        {modalType === 'Edit' && (
          <EditModal
            tenant={this.state.tenantDetails}
            openTenantModal={this.openTenantModal}
            closeTenantModal={this.closeTenantModal}
          />
        )}
        {modalType === 'Degrees' && (
          <UpdateDegreesModal
            openTenantModal={this.openTenantModal}
            closeTenantModal={this.closeTenantModal}
            tenant={this.state.tenantDetails}
          />
        )}
        {modalType === 'Careers' && (
          <UpdateCareersModal
            openTenantModal={this.openTenantModal}
            closeTenantModal={this.closeTenantModal}
            tenant={this.state.tenantDetails}
          />
        )}
      </>
    );
  };

  tenantModal = () => {
    const { loading, tenantDetails, modalType } = this.state;
    return (
      <>
        <div className="tenant-modal__overlay" />
        <div className="tenant-modal__modal-container">
          <div
            className="tenant-modal__close-button"
            role="button"
            tabIndex={0}
            onClick={() => {
              this.closeTenantModal();
            }}
            onKeyDown={(e) => {
              if (['Enter'].includes(e.key)) this.closeTenantModal();
            }}
          >
            <XIcon color="white" />
          </div>
          <div className="tenant-modal__modal-body">
            {loading ? <Loading height="90vh" /> : this.modalController()}
          </div>
        </div>
      </>
    );
  };

  render() {
    const { allTenants, loading, displayModal, tenantDetails } = this.state;
    return (
      <div className="tenants-tab">
        {displayModal && this.tenantModal()}
        <BoxWithShadow>
          <div className="tenants-tab__heading">
            <h1>{copy.heading}</h1>
            {this.props.role === 'Super User' && (
              <div
                tabIndex={0}
                role="button"
                className="tenants-tab__create"
                style={this.colorPrimary}
                onClick={() => this.openTenantModal('Create')}
                onKeyDown={(e) => {
                  if (['Enter'].includes(e.key)) this.openTenantModal('Create');
                }}
              >
                {copy.create}
                <div className="tenants-tab__plus-icon" style={this.plusIcon}>
                  +
                </div>
              </div>
            )}
          </div>
          {allTenants.length === 0 ? (
            <Loading height="100%" />
          ) : (
            allTenants.map((tenant) => (
              <Tenant
                tenant={tenant}
                key={tenant.id}
                openTenantModal={this.openTenantModal}
                updatePublishedAndRefresh={this.updatePublishedAndRefresh}
              />
            ))
          )}
        </BoxWithShadow>
      </div>
    );
  }
}

function mapStateToProps(state) {
  const role = getOnboardingState(state).userData.user.role;
  const tenant = getTenantState(state);
  return { role, tenant };
}

export default connect(mapStateToProps, {
  getAllTenants,
  getTenantDetails,
  updatePublishedAndGetTenants,
})(Tenants);
